// extracted by mini-css-extract-plugin
module.exports = {"github-card":"_2kCszUfEVAhA7yw8jrBthJ","githubCard":"_2kCszUfEVAhA7yw8jrBthJ"};